import { Button }                          from 'antd';
import rights                              from 'utils/rights';
import { IN_PROGRESS, REFUSED, VALIDATED } from 'constants/DemandStatuses';
import FormattedMessageWrapper             from 'components/App/FormattedMessageWrapper';
import MessageModel                        from 'models/MessageModel';
import DemandMessageModel                  from 'models/DemandMessageModel';
import { ApiCollection }                   from 'collections/ApiCollection';
import DemandStatusModel                   from 'models/DemandStatusModel';
import DemandModel                         from 'models/DemandModel';

const getForStatus = (demandStatusCollection: ApiCollection<DemandStatusModel>, statusReference: string) => {
  const demandStatus = demandStatusCollection.findBy('reference', statusReference);

  return demandStatus ? demandStatus.id : undefined;
};

const getAdditionalContent = (
  demand: DemandModel,
  demandStatusCollection: ApiCollection<DemandStatusModel>,
  openValidationDemandFormModal: (demandMessage: DemandMessageModel, message: MessageModel) => void,
) => {
  const demandStatus = demandStatusCollection.findBy('id', demand.demandStatusId);

  if (!demandStatus) {
    return {
      additionalContent: null,
      status: undefined,
    };
  }

  if (demandStatus.reference === IN_PROGRESS) {
    const forStatus = getForStatus(demandStatusCollection, IN_PROGRESS);

    if (rights.for.demand.newStatus) {
      return {
        additionalContent: (
          <Button
            block
            className="btn-validate-demand"
            htmlType="button"
            onClick={() =>
              openValidationDemandFormModal(new DemandMessageModel(), new MessageModel())
            }
            type="primary"
          >
            <FormattedMessageWrapper id="Valider la demande" />
          </Button>
        ),
        status: forStatus,
      };
    }

    return {
      additionalContent: (
        <div
          style={{
            backgroundColor: '#e67e22',
            color: 'white',
            padding: '4px 8px',
          }}
        >
          <FormattedMessageWrapper id="Votre demande est prise en compte, vous serez tenu informé de sa validation ou de son refus." />
        </div>
      ),
      status: forStatus,
    };
  }

  if (demandStatus.reference === REFUSED) {
    const forStatus = getForStatus(demandStatusCollection, REFUSED);

    return {
      additionalContent: (
        <div
          style={{
            backgroundColor: '#e74c3c',
            color: 'white',
            padding: '4px 8px',
          }}
        >
          <FormattedMessageWrapper id="La demande a été refusée." />
        </div>
      ),
      status: forStatus,
    };
  }

  if (demandStatus.reference === VALIDATED) {
    const forStatus = getForStatus(demandStatusCollection, VALIDATED);

    return {
      additionalContent: (
        <div
          style={{
            backgroundColor: '#2ecc71',
            color: 'white',
            padding: '4px 8px',
          }}
        >
          <FormattedMessageWrapper id="La demande a été validée." />
        </div>
      ),
      status: forStatus,
    };
  }

  return {
    additionalContent: null,
    status: undefined,
  };
};

export default getAdditionalContent;
